import type { Networkish } from "@/types";
import React from "react";

import UiTag from "@/components/Ui/Tag";
import UiTooltipUnsupported from "@/components/Ui/Tooltip/Unsupported";
import { classNames } from "@/utils";

interface UiPinnedToken {
  icon?: string;
  name: string;
  symbol: string;
  chainId: Networkish;
}

interface UiPinnedTokenProps {
  clickHandler?: any;
  token: UiPinnedToken;
  isSelected?: boolean;
  isUnsupported?: boolean;
}

export default function UiPinnedToken({ clickHandler, token, isSelected, isUnsupported = false }: UiPinnedTokenProps) {
  return (
    <UiTooltipUnsupported enable={isUnsupported}>
      <li
        className={classNames(
          clickHandler ? (isUnsupported ? "cursor-not-allowed" : "cursor-pointer") : "cursor-default",
          "flex flex-row items-center overflow-hidden rounded-full",
          clickHandler && !isUnsupported && (isSelected ? "hover:bg-primary-200/10" : "hover:bg-primary-200/20"),
          isSelected && "bg-primary-200/20"
        )}
        onClick={() => clickHandler && !isUnsupported && clickHandler(token)}
      >
        <UiTag asset={token} chainId={token.chainId} hasBorder isPinnedSmall className={classNames(isUnsupported && "opacity-44")} />
      </li>
    </UiTooltipUnsupported>
  );
}
